<div id="footerComponentId">
    <button mat-raised-button class="scroll-to-up-down" (click)="scrollToUpDown()">
        <mat-icon *ngIf="!scrollToUp">keyboard_arrow_down</mat-icon>
        <mat-icon *ngIf="scrollToUp">keyboard_arrow_up</mat-icon>
    </button>
</div>
